import React from 'react';
import {Button, Divider, Input, message, Modal, Select, Table} from 'antd';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";
import CommonUtils from "../../tools/CommonUtils";

const { Option } = Select;

export default class PurchaseOrderList extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            showMessageDialog: false,
            showGenerateModal: false,
            confirmLoading: false,
            planList: [],
            paymentStatusList: [],
            paymentWayList: [],
            selectedOrder: {},
            query_params: {},
            form_refund_params: {},
            form_recharge_params: {},
            form_resource_params: {}
        }
    }

    componentDidMount() {
        this.loadListData();
        this.loadPurchasePlanList();
    }

    setStateParams(params, name, value) {
        params[name] = value;
        this.setState(params);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});
    }

    handleInputFocus(event) {
        const target = event.target;
        if (target.type === 'text') {
            this.setState({showMessageDialog: false});
        }
    }

    loadListData(changedParams) {
        if (!changedParams) {
            changedParams = {
                currentPage: 1,
                pageSize: 10
            };
        }
        let params = this.state.query_params;
        params.currentPage = changedParams.currentPage;
        params.pageSize = changedParams.pageSize;

        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/charge-code-list', params)
            .then(response => {
                console.debug("query-order-list response -> " + JSON.stringify(response));
                this.setState({loading: false});
                if (response.code === 200) {
                    this.setState({
                        dataList: response.rows,
                        total: response.total,
                        currentPage: changedParams.currentPage,
                        pageSize: changedParams.pageSize
                    });
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    loadPurchasePlanList() {
        new WebServerRestClient().GET('/open/purchase-plans')
            .then(response => {
                console.log("load purchase-plan response -> " + JSON.stringify(response));
                if (response.code === 200) {
                    this.setState({planList: response.data})
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }


    render() {
        return (
            <div className="container">
                <div className="toolbar">
                    <Input placeholder="Owner"
                           className="search_input"
                           onChange={(event) => this.setStateParams(this.state.query_params, 'ownerUserId', event.target.value)}/>
                    <Divider type="vertical"/>
                    <Input placeholder="Code"
                           className="search_input"
                           onChange={(event) => this.setStateParams(this.state.query_params, 'code', event.target.value)}/>
                    <Divider type="vertical"/>
                  <Select className="search_input"
                          placeholder="Status"
                          allowClear={true}
                          onChange={(value) => this.setStateParams(this.state.query_params, 'status', value)}>
                        <Option key={0}>created</Option>
                        <Option key={1}>redeemed</Option>
                  </Select>
                    <Divider type="vertical"/>
                    <Button type="primary"  icon="search" className="search_btn" loading={this.state.doing}
                            onClick={this.loadListData.bind(this)}>
                        Search
                    </Button>
                    <Divider type="vertical"/>
                    <div className="button_group">
                        <Button type="link" icon="file-add" size={"small"}
                                onClick={this.openGenerateWindow.bind(this)}>Generate</Button>
                    </div>
                </div>

                <Table loading={this.state.loading}
                       rowKey={'orderId'}
                       columns={[
                           {title: 'Owner', dataIndex: 'ownerUserId', align: 'center'},
                           {title: 'Code', dataIndex: 'code', align: 'left'},
                           {title: 'Product', dataIndex: 'purchasePlanId', align: 'center'},
                           {title: 'Days', dataIndex: 'days', align: 'center' },
                           {title: 'Status', dataIndex: 'statusText', align: 'center' },
                           {title: 'CreatedTime', dataIndex: 'createdTime', align: 'center'},
                           {title: 'Redeemer', dataIndex: 'redeemerUserId', align: 'center'},
                           {title: 'RedeemTime', dataIndex: 'updatedTime', align: 'center'}
                       ]}
                       dataSource={this.state.dataList}
                       pagination={{
                           current: this.state.currentPage,
                           pageSize: this.state.pageSize,
                           total: this.state.total,
                           onChange: (currentPage, pageSize) => {
                               this.setState({loading: true});
                               this.loadListData({currentPage, pageSize});
                           },
                           showTotal: ((total) => {
                               return `total of ${total} records`;
                           }),
                           className: "pagination"
                       }}/>

                <Modal
                    keyboard={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    title="Generate Code"
                    visible={this.state.showGenerateModal}
                    onCancel={() => this.setState({showGenerateModal: false})}
                    onOk={() => this.generateCode()}
                    confirmLoading={this.state.confirmLoading}
                    okText="OK"
                    cancelText="Cancel">
                        <Input placeholder={'Owner User Id'}
                               className="mt_10 width_100"
                               value={this.state.form_recharge_params.ownerUserId}
                               onChange={(event) => this.setStateParams(this.state.form_recharge_params, 'ownerUserId', event.target.value)}/>
                        <Input placeholder={'Days'}
                               className="mt_10 width_100"
                               value={this.state.form_recharge_params.days}
                               onChange={(event) => this.setStateParams(this.state.form_recharge_params, 'days', event.target.value)}/>
                        <Input placeholder={'Quantity'}
                               className="mt_10 width_100"
                               value={this.state.form_recharge_params.quantity}
                               onChange={(event) => this.setStateParams(this.state.form_recharge_params, 'quantity', event.target.value)}/>
                </Modal>
            </div>
        )
    }

    openGenerateWindow() {
        let form_params = this.state.form_recharge_params;

        // reset value
        delete form_params.ownerUserId;
        delete form_params.purchasePlanId;
        delete form_params.quantity;
        this.setState({showGenerateModal: true});
    }

    generateCode() {
        let form_params = this.state.form_recharge_params;
        if(!form_params.ownerUserId || form_params.ownerUserId.trim().length === 0){
            message.warn('Parameters[ownerUserId] is empty!');
            return false;
        }
        if(!form_params.days || form_params.days === 0){
            message.warn('Parameters[days] is empty!');
            return false;
        }
        if(!form_params.quantity || form_params.quantity === 0){
            message.warn('Parameters[quantity] is empty!');
            return false;
        }

        this.setState({ confirmLoading: true});
        new WebServerRestClient().POST('/admin/generate-charge-code', form_params)
            .then(response => {
                CommonUtils.log("generate-charge-code response -> " + JSON.stringify(response));
                this.setState({confirmLoading: false});
                if (response.code === 200) {
                    this.setState({showGenerateModal: false});
                    this.loadListData();
                } else {
                    message.warn(response['msg']);
                }
            }).catch(err => {
            this.setState({confirmLoading: false});
            message.error("Error: " + err.message);
        });
    };

}
